/* import __COLOCATED_TEMPLATE__ from './chat.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();